"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerClipType = void 0;
var ProducerClipType;
(function (ProducerClipType) {
    ProducerClipType["CeremonyVideo"] = "ceremony";
    ProducerClipType["StudentVideo"] = "student";
})(ProducerClipType = exports.ProducerClipType || (exports.ProducerClipType = {}));
//# sourceMappingURL=producer-clip-type.js.map